<template lang="pug">
  .text-center.video-chat__footer
    ul.mb-0.list-unstyled.video-controller
      li.video-controller__item(
        v-for="(button, index) in buttons",
        :key="index",
        :data-index="index + 1"
      )
        component(
          :is="button.component",
          :data-index="index + 1",
          :on-mouse-enter="handleMouseEnter",
          :on-mouse-leave="handleMouseLeave"
        )
</template>

<script>
import { getDevice } from '../../utils/checkAppSupport'
import ShareScreenButton from './ShareScreenButton'
import MicrophoneButton from './MicrophoneButton'
import CameraButton from './CameraButton'
import ChatButton from './ChatButton'
import SettingButton from './SettingButton'
import LeaveButton from './LeaveButton'

export default {
  name: 'Footer',
  components: {
    ShareScreenButton,
    MicrophoneButton,
    CameraButton,
    ChatButton,
    SettingButton,
    LeaveButton
  },
  data () {
    return {
      buttons: [
        { component: ShareScreenButton },
        { component: MicrophoneButton },
        { component: CameraButton },
        { component: ChatButton },
        { component: SettingButton },
        { component: LeaveButton }
      ]
    }
  },
  computed: {
    max () {
      return this.buttons.length
    },
    stealth () {
      return this.$store.state.stealth
    }
  },
  created () {
    const device = getDevice().type

    // ステルスなら画面共有とマイクとカメラとセッティングボタンを消す
    if (this.stealth) {
      this.buttons = this.buttons.filter((button) => {
        return !['ShareScreenButton', 'MicrophoneButton', 'CameraButton', 'SettingButton'].includes(button.component.name)
      })
    }

    // デバイスがタブレットなら画面共有ボタンを消す
    if (device === 'tablet') {
      this.buttons = this.buttons.filter((button) => {
        return !['ShareScreenButton'].includes(button.component.name)
      })
    }

    // デバイスがスマホなら画面共有とレイアウトボタンを消す
    if (device === 'mobile') {
      this.buttons = this.buttons.filter((button) => {
        return !['ShareScreenButton'].includes(button.component.name)
      })
    }
  },
  methods: {
    handleMouseEnter (e) {
      // 隣り合わせ・その隣のindex値を算出
      const index = e.currentTarget.dataset.index
      const near = [index - 2, index - 1, index + 1, index + 2]

      const $parent = document.querySelector(`.video-controller__item[data-index="${index}"]`)
      $parent.classList.remove('is-nearest', 'is-near')

      near.forEach((near, index) => {
        // 値が0以下、ボタン数を超えてたら処理しない
        if (near < 1 || near > this.max) return
        const $target = document.querySelector(`.video-controller__item[data-index="${near}"]`)

        switch (index) {
          case 0:
          case 3:
            $target.classList.add('is-near')
            break
          case 1:
          case 2:
            $target.classList.add('is-nearest')
            break
          default:
            break
        }
      })
    },
    handleMouseLeave () {
      const items = document.querySelectorAll('.video-controller__item')

      items.forEach(($item) => {
        $item.classList.remove('is-nearest', 'is-near')
      })
    }
  }
}
</script>
